// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__mGL8W","iconWrap":"styles_iconWrap__7Y3iv"};
module.exports.__checksum = "db1b99fb3122"